import {Typography} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Inline radio button group
 * @param props
 *      groupName: required to avoid possible naming collisions (example two Yes/No sets on the same page)
 *      radioOptions: required array of possible options ex. ['Yes','No']
 *      onChange: required function for handling radio button changes
 *      currentlySelected: required string for checking currently selected radio button
 * @returns {*}
 */
export default function InlineRadioButtons (props) {
    const {groupName, radioOptions, onChange, currentlySelected} = props;

    return (
        radioOptions.map((item, index) => (
            <span key={`${groupName}-${item}-${index}`}>
                <Typography style={{display: 'inline'}} key={`${groupName}-radio-label-${index}`}>{item} &nbsp; </Typography>
                <Radio
                    key={`${groupName}-radio-${item}-${index}`}
                    checked={currentlySelected === item}
                    onChange={onChange}
                    value={item}
                    name={`radio-${groupName}-${item}`}
                    inputProps={{'aria-label': `${groupName}-${item}`}}
                />
            </span>
        ))
    );
}

InlineRadioButtons.propTypes = {
    groupName: PropTypes.string.isRequired,
    radioOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    currentlySelected: PropTypes.string.isRequired
};